module.exports = __webpack_public_path__ + "static/media/tag.a3d0a65b.svg";